import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyBlogTarget } from "@/lib/legacy-blog-paths";
import { withQuery } from "@/lib/redirect-query";

// Old WordPress /blog/* paths that have no dedicated route. The dedicated
// /blog/... routes match first. Keep the query string so ad and UTM tags
// survive.
export const Route = createFileRoute("/blog/$")({
  beforeLoad: ({ params, location }) => {
    throw redirect({ href: withQuery(legacyBlogTarget(params._splat ?? ""), location.searchStr), statusCode: 301 });
  },
});
